module.exports = __webpack_public_path__ + "img/simulationx2.93c5a019.png";